import React, {useState} from 'react';
import ModalSharedFilesListView from './ModalSharedFilesList-view';
import {
  getOrderFilesList,
  getSharedFilesList,
  getPrivateFilesList
} from '../../actions/files/getSharedOrPrivateFilesList';
import PropTypes from 'prop-types';

const ModalSharedFilesList = ({
                                file: {
                                  type,
                                  fileTypeID,
                                  onSubmit,
                                  folderID
                                },
                                shumaID,
                                stepID,
                                customStylesContainer
                              }) => {
  const [orderFiles, setOrderFiles] = useState([]);
  const [sharedFiles, setSharedFiles] = useState([]);
  const [privateFiles, setPrivateFiles] = useState([]);

  const handleGetFilesLists = () => {
    switch (type) {
      case 'order':
        return getOrderFilesList({shumaID, fileTypeID})
          .then((bodyForOrder) => {
            setOrderFiles(bodyForOrder.orderFilesList);
          });
      case 'shared':
        return getSharedFilesList({shumaID, fileTypeID})
          .then((bodyForShared) => {
            setSharedFiles(bodyForShared.sharedFilesList);
          });
      case 'private':
        return getPrivateFilesList({shumaID, fileTypeID})
          .then((bodyForPrivate) => {
            setPrivateFiles(bodyForPrivate.privateFilesList);
          });
      case 'order-shared':
        return Promise.all([
          getOrderFilesList({shumaID, fileTypeID}),
          getSharedFilesList({shumaID, fileTypeID}),
        ]).then(([bodyForOrder, bodyForShared]) => {
          setOrderFiles(bodyForOrder.orderFilesList);
          setSharedFiles(bodyForShared.sharedFilesList);
        })
      case 'order-private':
        return Promise.all([
          getOrderFilesList({shumaID, fileTypeID}),
          getPrivateFilesList({shumaID, fileTypeID}),
        ]).then(([bodyForOrder, bodyForPrivate]) => {
          setOrderFiles(bodyForOrder.orderFilesList);
          setPrivateFiles(bodyForPrivate.privateFilesList);
        })
      case 'shared-private':
        return Promise.all([
          getSharedFilesList({shumaID, fileTypeID}),
          getPrivateFilesList({shumaID, fileTypeID}),
        ]).then(([bodyForShared, bodyForPrivate]) => {
          setSharedFiles(bodyForShared.sharedFilesList);
          setPrivateFiles(bodyForPrivate.privateFilesList);
        })
      case 'all':
      default:
        return Promise.all([
          getOrderFilesList({shumaID, fileTypeID}),
          getSharedFilesList({shumaID, fileTypeID}),
          getPrivateFilesList({shumaID, fileTypeID}),
        ]).then(([bodyForOrder, bodyForShared, bodyForPrivate]) => {
          setOrderFiles(bodyForOrder.orderFilesList);
          setSharedFiles(bodyForShared.sharedFilesList);
          setPrivateFiles(bodyForPrivate.privateFilesList);
        });
    }
  };

  return (
    <ModalSharedFilesListView
      type={type}
      shumaID={shumaID}
      stepID={stepID}
      files={{
        order: orderFiles,
        shared: sharedFiles,
        private: privateFiles
      }}
      folderID={folderID}
      handleGetFilesLists={handleGetFilesLists}
      customStylesContainer={customStylesContainer}
      fileTypeID={fileTypeID}
      handleSubmit={onSubmit}
    />
  );
};

ModalSharedFilesList.propTypes = {
  file: PropTypes.shape({
    type: PropTypes.oneOf([
      'private',
      'order',
      'shared',
      'all',
      'order-shared',
      'order-private',
      'shared-private',
    ]),
    fileTypeId: PropTypes.number,
    onSubmit: PropTypes.func,
    folderID: PropTypes.number,
  }),
  shumaID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  stepID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  customStylesContainer: PropTypes.string,

};

export default ModalSharedFilesList;
